import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  copyVoucherTooltipText: {
    id: 'checkout.cartPage.copyVoucherTooltipText',
    defaultMessage: 'Copy voucher code',
    description: 'Text for tooltip when customer hover over copy icon',
  },
  voucherCopiedTooltipText: {
    id: 'checkout.cartPage.voucherCopiedTooltipText',
    defaultMessage: 'Code copied',
    description: 'Text for tooltip when customer copied voucher code using copy icon',
  },
});
